import { SET_CLEAN, SET_DIRTY } from '../actions'

// Keeps track of whether or not the form has been edited;
// Used in setting locked status and enabling save button
export default (dirty = false, action) => {
  switch (action.type) {
    case SET_CLEAN: 
      return false;
    case SET_DIRTY: 
      return true;
    default:
      return dirty;
  }
 
}